/*
 * @LastEditors: donsonwu
 * @Date: 2022-08-29 14:44:01
 * @LastEditTime: 2022-09-28 14:30:40
 * @Descripttion: 
 */

import * as milo from '@tencent/milo-web'
import { initPage } from '../diyWork/init'
import { plat, isPage , iActivityId, giftRecordId, giftRecordBtnClass, preRolePopId, wxBindPopId,realGiftRecordId,realGgiftRecordBtnClass } from '../diyWork/config'
import { giftRecord, TGDialogS,realGoodGift } from '../utils'
import LoginService from './loginService'
import { amsBtn } from './amsBtnTypeLimit' // 按钮类型限制的接口
export class AmsService {
  public allBtnPromise: Map<number, Promise<any>> = new Map()
  constructor (btn: Array<amsBtn>) {
    this.initBtnFunc(btn)
    if ((window as any).cfhdAmsBtnPromise == undefined) {
      (window as any).cfhdAmsBtnPromise = {}
    }
    ;(window as any).cfhdAmsBtnPromise[iActivityId] = this.allBtnPromise
    // 绑定
    this.bindGiftRecord()
    this.bingRealGiftRecordId()
  }
  public bindGiftRecord() {
    giftRecordBtnClass.forEach((ele, index) => {
      if ($(ele).length >0) {
        $(ele).click(function(){
          giftRecord(iActivityId, giftRecordId[index])
        })
      } else {
        console.log(`没有礼包记录${ele}按钮，不执行绑定`)
      }
    })
  }
  public bingRealGiftRecordId() {
    realGgiftRecordBtnClass.forEach((ele, index) => {
      if ($(ele).length >0) {
        $(ele).click(function(){
          realGoodGift(iActivityId, realGiftRecordId[index])
        })
      } else {
        console.log(`没有礼包记录${ele}按钮，不执行绑定`)
      }
    })
  }
  /**
   * @param {Array} btn
   * @return { void }
   * @description: 1.将数组转为promise，存入数组 2. 按钮class绑定好事件 3. promise数组会暴露到全局
   */  
  private initBtnFunc (btn: Array<amsBtn>): void {
    btn.forEach((ele) => {
      // 处理前置before
      let beforeFunc = ele.before || function () { return true }
      // 处理成功回调和失败回调函数
      const resolveFunc = function (callbackObj) {
        let msg = '';
        if (ele.customMsg != undefined) {
          msg = ele.customMsg;
        }else{
          msg = callbackObj.sMsg || callbackObj.msg
        }
        // 成功回调
        
        if (ele.resolve) {
          ele.resolve(callbackObj,ele);
          if(ele.customMsg){
            milo.miloAlert(ele.customMsg)
          }
        }else{
          milo.miloAlert(msg)
        }
        //if (!ele.needInitSubmit && parseInt(callbackObj.iRet) == 0 && ele.key && (window as any).cfhdCallbackObj[iActivityId][ele.key] && (window as any).cfhdCallbackObj[iActivityId][ele.key].length > 0) {
        if (!ele.needInitSubmit && parseInt(callbackObj.iRet) == 0 ) {
          // 先处理好资格变化
          if (ele.postion != undefined) {
            // 有具体位置处理资格，不然就直接处理整个 output变化
            const zigeList = (window as any).cfhdCallbackObj[iActivityId][ele.key].split(',')
            const newNum: number = parseInt(zigeList[ele.postion]) + 1
            zigeList[ele.postion] = newNum
            ;(window as any).cfhdCallbackObj[iActivityId][ele.key] = zigeList.join(',')
          }
          if (ele.jfHandleList && ele.jfHandleList.length > 0) {
            ele.jfHandleList.forEach((ele) => {
              const jfList = (window as any).cfhdCallbackObj[iActivityId][ele.key].split(',')
              const tmp = callbackObj.jExtend || 0
              const newJfNum: number = ele.method === 'incr'? parseInt(jfList[ele.position]) + parseInt(tmp)|| 0 : parseInt(jfList[ele.position]) - parseInt(tmp) || 0
              jfList[ele.position] = newJfNum
              ;(window as any).cfhdCallbackObj[iActivityId][ele.key] = jfList.join(',')
            })
          }
          // 执行初始化的js
          initPage(false)
        } else {
          if(!ele.needInitSubmit){
            initPage(false)
          }else{
            // 直接请求AMS进行初始化
            initPage()
          }
        }
      }
      const rejectFunc = function (callbackObj) {
        if (ele.reject) ele.reject(callbackObj,ele)
        else {
          const msg = callbackObj.sMsg || callbackObj.msg
          if (callbackObj.iRet == '202') {
            TGDialogS(wxBindPopId)
            milo.miloAlert(msg)
          } else if (msg === '抱歉，您还没有角色，无法参与~' || msg === '抱歉，您还未拥有角色，无法参与~') {
            // 拉起来预创角
            milo.miloAlert(msg)
            TGDialogS(preRolePopId)
          } else {
            milo.miloAlert(msg)
          }
        }
      }
      // 处理额外的参数
      const sDataName = `sData${ele.class}`
      ;(window as any)[sDataName] = {}
      if (ele.params && typeof ele.params == 'object' && Object.keys(ele.params).length > 0) {
        Object.keys(ele.params).forEach(function (e) {
          ;(window as any)[sDataName][e] = (ele.params as object)[e]
        })
      }
      // 生成promise放入map内
      const amsPromise = milo.Lottery.init({
        plat: plat,
        iActivityId: ele?.config?.iActivityId || iActivityId,
        iFlowId: ele.flowId,
        withAreaInfo: false,
        forbidLoading: ele.needMask || true,
        flowConfig: {
          sData: (window as any)[sDataName]
        },
        onSuccess: (res) => {
          resolveFunc(res)
        },
        onFail: (err) => {
          rejectFunc(err)
        },
      })
      this.allBtnPromise.set(ele.flowId,amsPromise)
      const lotteryFunc = function() {
        // 先校验登录，再抽奖
        LoginService(isPage).checkAndLogin().then(() => {
          amsPromise.then((lottery) => {
            const res = beforeFunc(ele)
            res && lottery.getGift()
          })
        })
      }
      // 绑定点击
      $(ele.class).unbind('click')
      if (!ele.notNeedSubmit && $(ele.class).length > 0) $(ele.class).click(lotteryFunc)
      else console.log('此class未绑定,或不需要立即提交：', ele.class, ele)
    })
  }
  /**
   * @param {number} flowId 流程id
   * @return {*} 返回该流程id对应的promise，方便开发调用
   * @description: 
   */  
  public getPromiseByFlowId (flowId: number) {
    return this.allBtnPromise.get(flowId) 
  }
  /**
   * @param {*} classKey 按钮的class
   * @param {*} key sData的key
   * @param {*} val sData的val
   * @return {*}
   * @description: 适用于ams条件之前，修改sData的值
   */  
  public setAmsSDATA (classKey, key, val) {
    ;(window as any)[`sData${classKey}`][key] = val
  }
}